var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"u-display-flex u-justify-content-between"},[_c('div',[_vm._v("TMS COOL ZONE APP © "+_vm._s(new Date().getFullYear()))]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{attrs:{"href":"https://tmsgrup.com","target":"_blank"}},[_c('img',{attrs:{"src":require("@/assets/images/Logo.webp"),"alt":"logo","width":"80"}})])])
}]

export { render, staticRenderFns }